export default {
  Model: {
    ID: 'id',
    UUID: 'uuid',
    BODY: 'body',
    BODY_RAW_TEXT: 'bodyRawText',
    WORKSPACE_ITEM_ID: 'workspaceItemId',
    AUTHOR_ID: 'authorId',
    IS_EDITED: 'isEdited',
    MEETING_MODE_SESSION_ID: 'meetingModeSessionId',
    UPDATED_AT: 'updatedAt',
    CREATED_AT: 'createdAt',
  },
  Actions: {
    FETCH_WORKSPACE_ITEM_COMMENTS_SUCCESS: 'workspace_comments/FETCH_WORKSPACE_ITEM_COMMENTS_SUCCESS',
    DELETE_WORKSPACE_ITEM_COMMENT_SUCCESS: 'workspace_comments/DELETE_WORKSPACE_ITEM_COMMENT_SUCCESS',
    UPDATE_WORKSPACE_ITEM_COMMENT_SUCCESS: 'workspace_comments/UPDATE_WORKSPACE_ITEM_COMMENT_SUCCESS',
    CREATE_WORKSPACE_ITEM_COMMENT_SUCCESS: 'workspace_comments/CREATE_WORKSPACE_ITEM_COMMENT_SUCCESS',
  },
  State: {
    WORKSPACE_ITEM_COMMENTS_BY_MEETING_ITEM_SLUG: 'WORKSPACE_ITEM_COMMENTS_BY_MEETING_ITEM_SLUG',
  },
};
